<template>
    <div>
        <form class="w-55" @submit.prevent="updateSearch">
            <div class="input-group mb-3">
                <v-select class="vselect-border vselect-fix mb-2 mr-2" v-model="search.country" :options="countries" placeholder="Country" />
                <v-select class="vselect-border vselect-fix mb-2" v-model="search.region" :options="regions" placeholder="Region" />
                <div class="input-group-append mb-2">
                    <button type="submit" class="btn btn-green search-btn" aria-label="Search" title="Search">&nbsp;</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import {formatToTitleCase, formatForURL} from '../Helpers';

export default {
    name: 'search-developments-form',
    data() {
        return {
            base_url: '',
            data: [],
            search: {
                country: '',
                region: ''
            },
            search_old: {
                country: '',
                region: ''
            }
        };
    },
    created() {
        this.base_url = window.Propuno.base_url;
        this.data = window.Propuno.country_regions;
        this.loadSearchFormFromURL();

        window.onpopstate = (event) => {
            window.Lozad.observe();
            this.loadSearchFormFromURL();
            window.Livewire.emit('searchChanged', {
                'country': this.search.country,
                'region': this.search.region
            });
        };
    },
    methods: {
        loadSearchFormFromURL: function() {
            this.resetSearchForm();
            var url = window.location.href.includes("?") ? window.location.href.substring(0, window.location.href.indexOf("?")) : window.location.href;
            var segments = url.split("/");

            for (var i = 0; i < segments.length; i++) {
                if (segments[i].toLowerCase() == "in" && segments[i + 1]) {
                    var country = formatToTitleCase(decodeURIComponent(segments[i + 1].split("-").join(" ")));
                    if (this.countries.includes(country)) {
                        this.search.country = country;
                    }

                    if (segments[i + 2]) {
                        var region = formatToTitleCase(decodeURIComponent(segments[i + 2].split("-").join(" ")));
                        if (this.regions.includes(region)) {
                            this.search.region = region;
                        }
                    }
                }
            }
        },
        resetSearchForm: function() {
            this.search = {
                country: '',
                region: ''
            };

            this.search_old = {
                country: '',
                region: ''
            };
        },
        updateSearch: function() {
            if (JSON.stringify(this.search) != JSON.stringify(this.search_old)) {
                this.search_old = {
                    country: this.search.country,
                    region: this.search.region
                };

                this.updateURL();
                window.Livewire.emit('searchChanged', {
                    'country': this.search.country,
                    'region': this.search.region
                });
            }
        },
        updateURL: function() {
            var url = this.base_url;
            var title = "Developments";

            if (this.search.country) {
                url += "new-developments/" + formatForURL(this.search.country);
                title += " in " + this.search.country;
                if (this.search.region) {
                    url += formatForURL(this.search.region);
                    title += " " + this.search.region;
                }
            }

            document.title = title + ' | Propuno';
            var state = {
                title: title,
                url: url
            };

            history.pushState(state, title, url);
        }
    },
    computed: {
        selectedCountry() {
            return this.search.country;
        },
        countries() {
            return Object.keys(this.data);
        },
        regions() {
            return this.data[this.search.country];
        }
    },
    watch: {
        selectedCountry: function(newVal, oldVal) {
            if (oldVal != '') {
                this.search.region = '';
            }
        }
    }
}
</script>

<style scoped>
    .vs--disabled .vs__dropdown-toggle, .vs--disabled .vs__clear, .vs--disabled .vs__search, .vs--disabled .vs__selected, .vs--disabled .vs__open-indicator {
        cursor: not-allowed;
        background-color: #fff;
    }
</style>
